import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonCard, IonCardContent, IonItem, IonLabel, IonSpinner } from '@ionic/angular';
import { AsyncPipe } from '@angular/common';
import { LoadingToastController } from '@raptor-fe/services';

@Component({
  selector: 'lib-loading-toast',
  template: `
    @if (loadingItems$ | async; as loadingItems) { @if (loadingItems.length > 0)
    {
    <ion-card class="ios-bottom-safe-zone">
      <ion-card-content>
        @for (loadingItem of loadingItems; track loadingItem) {
        <ion-item>
          <ion-label class="ion-margin-end">
            Uploading {{ loadingItem.name }}
          </ion-label>
          <ion-spinner></ion-spinner>
        </ion-item>
        }
      </ion-card-content>
    </ion-card>
    } }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCard, IonCardContent, IonItem, IonLabel, IonSpinner, AsyncPipe],
  styles: [
    `
      ion-card {
        position: fixed;
        bottom: var(--ios-bottom-safe-zone);
        right: 0;
        z-index: 0;
      }
      ion-item,
      ion-card-content {
        margin: 0;
        padding: 0;
      }

      ion-item:last-child {
        --border-style: none;
      }
    `,
  ],
})
export class LoadingToastComponent {
  protected readonly loadingItems$: typeof this.toastLoader.loadingItems$;

  private readonly toastLoader = inject(LoadingToastController)

  constructor() {
    this.loadingItems$ = this.toastLoader.loadingItems$;
  }
}


